<template>
  <alert-card
    display="scroll-window"
    :primaryHeading="`Unsigned Contracts (${unsignedEvents.length})`"
  >
    <contact-event-details
      v-for="(event, index) in unsignedEvents"
      :key="index"
      :event="event"
      :requests="['formatted-date', 'total']"
      class="unsigned-contract-list-item"
      @click="navigateToEvent(event)"
    />
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
import ContactEventDetails from "../../../Components/UI/ListItems/Event/ContactEventDetails.vue";
import { unsignedEvents } from "../../../Helpers/events.js";
export default {
  data() {
    return {};
  },
  computed: {
    unsignedEvents() {
      return unsignedEvents();
    },
  },
  methods: {
    navigateToEvent(event) {
      this.$router.push(`/event/${event.tenantId}/${event.userId}`);
    },
  },
  components: { AlertCard, ContactEventDetails },
};
</script>
<style scoped>
.unsigned-contract-list-item {
  height: 40px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
